import { useEffect,useState } from 'react';

import XIcon from '@/shared-components/icons/components/public/XIcon';
import Text from '@/shared-components/text/components/Text';

import Suggestions from './suggestions';

import './index.css';

export default function Search({ addTag, formState }) {
  const [openSuggestions, setOpenSuggestions] = useState(false);
  const [query, setQuery] = useState({ q: "" });
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [suggestions, setSuggestions] = useState([]);
  
  // Move selection up/down and pick with Enter
  function handleKeyDown(e) {
    if (!openSuggestions) return;

    // Assume Suggestions renders items from formState.post_tags_suggestions
    const items = suggestions; 
    switch (e.key) {
    case 'ArrowDown':
      e.preventDefault();
      setSelectedIndex(i => {
        const next = Math.min(i + 1, items.length - 1);
        return next;
      });
      break;
    case 'ArrowUp':
      e.preventDefault();
      setSelectedIndex(i => {
        const prev = Math.max(i - 1, 0);
        return prev;
      });      break;
    case 'Enter':
      e.preventDefault();
      if (items[selectedIndex]) {
        addTag(items[selectedIndex]);
      }
      break;
    default:
      break;
    }
  }

  // whenever our query changes, reset the highlighted row
  useEffect(() => {
    setSelectedIndex(0);
  }, [query.q]);

  function handleTagsSuggestions() {
    if(query.q.length > 1) {
      setOpenSuggestions(true);
    } else {
      setOpenSuggestions(false);
    }
  }

  useEffect(() => { 
    handleTagsSuggestions(); 
    // reset selection if suggestions closed
  }, [query.q]);

  return (
    <>
      <div className="post-tags__search-container">
        <div className="post-tags__search-bar">
          <Text className="post-tags__search-username-entry font-size-large">
                        @
          </Text>

          <input 
            type="text" 
            className="post-tags__search-input" 
            placeholder="Enter username..." 
            autoComplete="off" 
            spellCheck={false} 
            autoFocus    
            value={query.q} 
            onFocus={handleTagsSuggestions} 
            onBlur={() => {
              // give keyDown a tick to run first
              setTimeout(() => setOpenSuggestions(false), 0);
            }}            onInput={(e)=>setQuery({ q: e.target.value })}
            onKeyDown={handleKeyDown}
          />

          {query.q.length > 0 && <XIcon className="post-tags__delete-input" onClick={()=>setQuery({ q: "" })}/>}
        </div>

        {openSuggestions && (
          <Suggestions
            query={query}
            addTag={addTag}
            formState={formState}
            selectedIndex={selectedIndex}
            onSuggestionsChange={setSuggestions}
          />
        )}
      </div>
    </>
  );
}
